import { render, staticRenderFns } from "./mtgindex.vue?vue&type=template&id=6eacd25e&scoped=true"
import script from "./mtgindex.vue?vue&type=script&lang=js"
export * from "./mtgindex.vue?vue&type=script&lang=js"
import style0 from "./mtgindex.vue?vue&type=style&index=0&id=6eacd25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eacd25e",
  null
  
)

export default component.exports